import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  MoreOutlined,
} from "@ant-design/icons";
import { Badge, Dropdown, Space, Switch, Table } from "antd";
import TableAntd from "components/elements/Table/Table";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
const WelfareTable = ({
  isLoading = false,
  pagination = {},
  dataSource = [],
  onEdit = () => { },
  onDelete = () => { },
  onStatus = () => { },
  onChange = () => { },
}) => {
  console.log('pag', pagination);

  const { t, i18n } = useTranslation();
  const { roles } = useSelector((state) => state.company);
  const columns = [
    {
      title: <div className="text-table">{t("common.index")}</div>,
      dataIndex: "index",
      key: "index",
      align: "center",
      width: 100,
      render: (_, record, idx) => {
        return <Badge count={(pagination.page - 1) * pagination.size + idx + 1} style={{ backgroundColor: "#F5F6F7", color: "#313131" }} />
      },
    },
    {
      title: <div className="text-table" style={{ textAlign: "center" }}>{t("welfare.label.name")}</div>,
      dataIndex: "welfareName",
      key: "welfareName",
      width: 180,
      // sorter: {
      //   compare: (a, b) => null,
      //   multiple: 2,
      // },
      render: (_, record) => {
        const name =
          i18n.language === "en" ? record.welfareNameEn : record.welfareName;
        return <span style={{ color: "#42526D" }}>{name}</span>;
      },
    },
    {
      title: <div className="text-table" style={{ textAlign: "center" }}>{t("welfare.label.type")}</div>,
      dataIndex: "welfareType",
      key: "welfareType",
      width: 180,
      align: "center",
      render: (_, record) => {
        const welfareTypeName =
          i18n.language === "en" ? record?.subcategoryDetails?.commonTypeNameEn : record?.subcategoryDetails?.commonTypeName;
        return <span style={{ color: "#42526D" }}>{welfareTypeName}</span>;
      },
    },
    {
      title: <div className="text-table" style={{ textAlign: "center" }}>{t("welfare_list.Expense_type")}</div>,
      dataIndex: "expenseType",
      key: "expenseType",
      width: 180,
      align: "center",
      render: (_, record) => {
        const expenseType =
          i18n.language === "en" ? record?.welfareTypeDetails?.commonTypeNameEn : record?.welfareTypeDetails?.commonTypeName;
        return <span style={{ color: "#42526D" }}>{expenseType}</span>;
      },
    },
    {
      title: <div className="text-table" style={{ textAlign: "center" }}>{t("welfare.label.description")}</div>,
      dataIndex: "description",
      key: "description",
    },
    {
      title: <div className="text-table">{t("welfare.label.status")}</div>,
      dataIndex: "statusFlag",
      key: "statusFlag",
      align: "center",
      width: 100,
      render: (text, record) => (
        <Switch
          checked={record?.statusFlag === "ACTIVE"}
          onChange={(checked) => onStatus(checked, record)}
          disabled={roles.includes("UPDATE_CONFIGURATION|PAYROLL_SETTING|WELFARE") ? false : true}
        />
      ),
    },
    roles.includes("UPDATE_CONFIGURATION|PAYROLL_SETTING|WELFARE",
      "DELETE_CONFIGURATION|PAYROLL_SETTING|WELFARE") ? {
      title: "",
      key: "action",
      align: "center",
      width: 120,
      render: (_, record) => (
        <Space size="middle">
          <Dropdown
            menu={{
              items: [
                roles.includes("UPDATE_CONFIGURATION|PAYROLL_SETTING|WELFARE") && {
                  key: "1",
                  onClick: () => onEdit(record),
                  label: `${t("action.edit")}`,
                  icon: (
                    <EditOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
                roles.includes("DELETE_CONFIGURATION|PAYROLL_SETTING|WELFARE") && (record?.initialFlag == "N") && {
                  key: "2",
                  onClick: () => onDelete(record),
                  label: `${t("action.delete")}`,
                  icon: (
                    <DeleteOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
              ],
            }}
          >
            <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
          </Dropdown>
        </Space>
      ),
    } : {},
  ];

  return (
    <TableAntd
      loading={isLoading}
      pagination={{
        ...pagination,
        showTotal: (total, range) =>
          t("paginate.description")
            .replace("{min}", range[0])
            .replace("{max}", range[1])
            .replace("{total}", total),
      }}
      dataSource={dataSource}
      rowKey={(record) => record.id}
      columns={columns}
      onChange={onChange}
      scroll={{ x: true }}
    />
  );
};

export default WelfareTable;
